import { Component, Input, OnInit } from '@angular/core';
import { DemonstrativoResultado as DemonstrativoResultado } from './../dr.model';

@Component({
  selector: 'app-dr-filho, [app-dr-filho]',
  templateUrl: './dr-filho.component.html',
  styleUrls: ['./dr-filho.component.scss']
})
export class DrFilhoComponent {
  // @Input() dre: DemonstrativoResultado[];
  // @Input() drId: number;
  @Input() dr: DemonstrativoResultado;
  constructor() { }

  // public obterFilhos(id) {
  //   return this.dre.filter(x => x.GrupoId === id);
  // }

  // MostrarFilhos(id) {
  //   this.dre.filter(x => x.Id === id).forEach(e => {
  //     e.MostrarFilhos = e.MostrarFilhos ? false : true;
  //   });
  // }
}
